export default "__VITE_ASSET__b3r7kXX5__"